import { http } from './http'

export function getKitchenContractors () {
  return http.get('/api/kitchen/contractors')
}

export function createKitchenContractor (payload) {
  return http.post('/api/kitchen/contractors', payload)
}

export function updateKitchenContractor (id, payload) {
  return http.put(`/api/kitchen/contractors/${id}`, payload)
}

export function setKitchenContractorActive (id, active) {
  return http.put(`/api/kitchen/contractors/${id}/active`, { active })
}

export function getKitchenContractorChildren (id) {
  return http.get(`/api/kitchen/contractors/${id}/children`)
}
